import React from "react";
import {TableContainer} from "./ComponentStyles";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../hooks/useStore";
import moment from "moment-timezone";
import {CourierLink} from "../../_defaultComponents/CourierLink/CourierLink";
import {TableWrapper} from "../../_defaultComponents/TableWrapper/TableWrapper";
import {ResponsiveDataTable} from "components/_defaultComponents/ResponsiveDataTable";

const FutureShiftsTable = ({
    data,
    setData,
    loading,
    setReloadData,
    currentPage,
    setCurrentPage,
    setReloadCount,
    dataCount
}) => {
    const {t} = useTranslation(["shiftScore", "shiftReportStatuses"]);
    const stores = useStore();
    const isNonApiIntegratedCustomer = stores.meStore.checkRole("isNonApiIntegratedCustomer");

    return (
        <>
            {isNonApiIntegratedCustomer ? (
                <ResponsiveDataTable
                    size="middle"
                    pagination={{
                        total: dataCount,
                        current: currentPage,
                        onChange: async page => {
                            setCurrentPage(page);
                        },
                        hideOnSinglePage: true,
                        showSizeChanger: false,
                        pageSize: 10
                    }}
                    rowKey="_id"
                    dataSource={data}
                    data-testid="futureShiftsTable"
                    loading={loading}
                    display={data.length > 0 ? "grid" : "flex"}
                >
                    <TableWrapper.Column
                        dataIndex="date"
                        title={t("fields.date", {ns: "common"})}
                        render={date => (
                            <span data-testid="futureShiftsDate">
                                {!date ? "-" : moment(date, "DD-MM-YYYY").format("DD.MM.YYYY")}
                            </span>
                        )}
                        onCell={() => ({
                            "data-label": t("fields.date", {ns: "common"})
                        })}
                    />
                    <TableWrapper.Column
                        dataIndex="fullname"
                        title={t("fields.courier", {ns: "common"})}
                        render={(fullname, data) => (
                            <span data-testid="fullname">
                                {stores.meStore.checkRole("courierDetail") ? (
                                    <CourierLink
                                        target="_blank"
                                        to={`/couriers/${data?.courierId ||
                                            data?.beforeLog?.courierId}`}
                                    >
                                        {fullname}
                                    </CourierLink>
                                ) : (
                                    fullname
                                )}
                            </span>
                        )}
                        onCell={() => ({
                            "data-label": t("fields.courier", {ns: "common"})
                        })}
                    />

                    {(stores.meStore.checkRole("userPermission") ||
                        stores.meStore.auth?.companies?.length !== 1) && (
                        <TableWrapper.Column
                            dataIndex="companyName"
                            title={t("fields.company", {ns: "common"})}
                            render={(companyName, row) => (
                                <>
                                    <span data-testid="companyName">{companyName}</span>
                                </>
                            )}
                            onCell={() => ({
                                "data-label": t("fields.company", {ns: "common"})
                            })}
                        />
                    )}

                    {(stores.meStore.checkRole("userPermission") ||
                        stores.meStore.auth?.subCompany === undefined ||
                        stores.meStore.auth?.subcompanies?.length > 1) && (
                        <TableWrapper.Column
                            dataIndex="subCompanyName"
                            title={t("fields.subcompany", {ns: "common"})}
                            render={(subCompanyName, row) => (
                                <>
                                    <span data-testid="subCompanyNmae">{subCompanyName}</span>
                                </>
                            )}
                            onCell={() => ({
                                "data-label": t("fields.subcompany", {ns: "common"})
                            })}
                        />
                    )}

                    <TableWrapper.Column
                        dataIndex="shiftStartTime"
                        title={t("shiftScore.scheduledShift", {ns: "shiftScore"})}
                        render={(shiftStartTime, row) => (
                            <span data-testid="date">
                                {[row?.shiftStartTime, row?.shiftEndTime].join(" - ")}
                            </span>
                        )}
                        onCell={() => ({
                            "data-label": t("shiftScore.scheduledShift", {ns: "shiftScore"})
                        })}
                    />
                </ResponsiveDataTable>
            ) : (
                <ResponsiveDataTable
                    size="middle"
                    pagination={{
                        total: dataCount,
                        current: currentPage,
                        onChange: async page => {
                            setCurrentPage(page);
                        },
                        hideOnSinglePage: true,
                        showSizeChanger: false,
                        pageSize: 10
                    }}
                    rowKey="_id"
                    dataSource={data}
                    data-testid="futureShiftsTable"
                    loading={loading}
                    display={data.length > 0 ? "grid" : "flex"}
                >
                    <TableContainer.Column
                        dataIndex="date"
                        title={t("fields.date", {ns: "common"})}
                        render={date => (
                            <span data-testid="futureShiftsDate">
                                {!date ? "-" : moment(date, "DD-MM-YYYY").format("DD.MM.YYYY")}
                            </span>
                        )}
                        onCell={() => ({
                            "data-label": t("fields.date", {ns: "common"})
                        })}
                    />
                    <TableContainer.Column
                        dataIndex="fullname"
                        title={t("fields.courier", {ns: "common"})}
                        render={(fullname, data) => (
                            <span data-testid="fullname">
                                {stores.meStore.checkRole("courierDetail") ? (
                                    <CourierLink
                                        target="_blank"
                                        to={`/couriers/${data?.courierId ||
                                            data?.beforeLog?.courierId}`}
                                    >
                                        {fullname}
                                    </CourierLink>
                                ) : (
                                    fullname
                                )}
                            </span>
                        )}
                        onCell={() => ({
                            "data-label": t("fields.courier", {ns: "common"})
                        })}
                    />

                    {(stores.meStore.checkRole("userPermission") ||
                        stores.meStore.auth?.companies?.length !== 1) && (
                        <TableContainer.Column
                            dataIndex="companyName"
                            title={t("fields.company", {ns: "common"})}
                            render={(companyName, row) => (
                                <>
                                    <span data-testid="companyName">{companyName}</span>
                                </>
                            )}
                            onCell={() => ({
                                "data-label": t("fields.company", {ns: "common"})
                            })}
                        />
                    )}

                    {(stores.meStore.checkRole("userPermission") ||
                        stores.meStore.auth?.subCompany === undefined ||
                        stores.meStore.auth?.subcompanies?.length > 1) && (
                        <TableContainer.Column
                            dataIndex="subCompanyName"
                            title={t("fields.subcompany", {ns: "common"})}
                            render={(subCompanyName, row) => (
                                <>
                                    <span data-testid="subCompanyNmae">{subCompanyName}</span>
                                </>
                            )}
                            onCell={() => ({
                                "data-label": t("fields.subcompany", {ns: "common"})
                            })}
                        />
                    )}

                    <TableContainer.Column
                        dataIndex="shiftStartTime"
                        title={t("shiftScore.scheduledShift", {ns: "shiftScore"})}
                        render={(shiftStartTime, row) => (
                            <span data-testid="date">
                                {[row?.shiftStartTime, row?.shiftEndTime].join(" - ")}
                            </span>
                        )}
                        onCell={() => ({
                            "data-label": t("shiftScore.scheduledShift", {ns: "shiftScore"})
                        })}
                    />
                </ResponsiveDataTable>
            )}
        </>
    );
};

export default FutureShiftsTable;
